import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import ButtonCmp from 'src/components/ButtonCmp';

interface IStepperAction {
    handleBack?: () => void;
    handleNext: () => boolean | Promise<boolean> | void | Promise<void>;
    backButtonText?: string;
    nextButtonText?: string;
    draftButtonText?: string;
    handleDraft?: () => void | Promise<any> | any;
    isNextButtonDisabled?: boolean;
    isDraftButtonDisabled?: boolean;
    isNextButtonLoading?: boolean;
    autoSaveDraftOnNext?: boolean; // New prop to enable auto-save on next
    onAfterDraftSave?: () => void; // Callback after draft is saved successfully
    className?: string;
    handleSwapClick?: () => void;
    isSwapButtonDisabled?: boolean;
}

const StepperAction: FC<IStepperAction> = ({
    handleBack,
    handleNext,
    backButtonText = 'Back',
    nextButtonText = 'Next',
    isNextButtonDisabled = false,
    isNextButtonLoading = false,
    className = '',
    handleSwapClick = undefined,
    isSwapButtonDisabled = false,
}) => {
    const { t } = useTranslation();

    return (
        <>
            <div className="bg-white">
                <div className={`stepper-content-container justify-between ${className}`}>
                    <div className="flex gap-x-2">
                        {handleSwapClick && (
                            <ButtonCmp type="button" className="btn_secondary_black" onClick={handleSwapClick} disabled={isSwapButtonDisabled}>
                                {t('Common.Swap_Addresses')}
                            </ButtonCmp>
                        )}
                        {handleBack && (
                            <ButtonCmp type="button" className="btn_secondary_black" onClick={handleBack}>
                                {backButtonText}
                            </ButtonCmp>
                        )}

                        <ButtonCmp type="button" className="btn-outline-primary" onClick={handleNext} disabled={isNextButtonDisabled || isNextButtonLoading} loading={isNextButtonLoading}>
                            {nextButtonText}
                        </ButtonCmp>
                    </div>
                </div>
            </div>
        </>
    );
};

export default StepperAction;
